
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Exercises",
      function () {
        return require("private-next-pages/Exercises.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Exercises"])
      });
    }
  